import React from 'react';

interface ImageProps
  extends React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  > {
  className?: string;
}

export default function Image(props: ImageProps) {
  return (
    <div className={props.className || ''}>
      <img loading='lazy' decoding='async' {...props} />
    </div>
  );
}
